import React from 'react';
import { Users, Target, Trophy, Zap } from 'lucide-react';

export const StatsSection = () => {
  const stats = [
    { icon: Users, value: '1000+', label: 'Runners' },
    { icon: Target, value: '4', label: 'Distances' },
    { icon: Trophy, value: '1st', label: 'Annual Event' },
    { icon: Zap, value: '100%', label: 'Country Charm' },
  ];

  return (
    <section className="section-full bg-foreground text-background py-12 sm:py-16 lg:py-20">
      <div className="container-wide px-4 sm:px-6">
        <h2 className="display-title text-white text-4xl sm:text-5xl md:text-6xl text-center mb-8 sm:mb-10 lg:mb-12">
          Why Run With Us?
        </h2>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-12">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div key={index} className="text-center scroll-reveal">
                <Icon className="mx-auto mb-3 sm:mb-4 text-primary" size={32} strokeWidth={1.5} />
                <div className="text-4xl sm:text-5xl lg:text-6xl font-black mb-1 sm:mb-2" style={{ fontFamily: 'Bebas Neue, cursive' }}>
                  {stat.value}
                </div>
                <div className="text-xs sm:text-sm uppercase tracking-widest font-bold opacity-70">
                  {stat.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
